import { RepositoryFactory } from "../../api/RepositoryFactory";
import ApiErrorHandler from "@/_helpers/apiErrorHandler.js";

const DeviceDataRepository = RepositoryFactory.get("devicedatas");

export const deviceDatas = {
  namespaced: true,
  state: {
    datas: [],
    status: {
      loading: false,
    },
  },

  actions: {
    async getByDevice(
      { dispatch, commit, rootState },
      { deviceId, limit = 100 }
    ) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;

      await DeviceDataRepository.getByDevice(user, deviceId, `limit=${limit}`)
        .then((datas) => {
          commit("SET_DATAS", datas.data);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },

    async getByCompany({ dispatch, commit, rootState }) {
      commit("LOADING", true);

      var user = rootState.users.currentUser;
      var companyId = rootState.users.userCompany.companyId;

      await DeviceDataRepository.getByCompany(user, companyId, "")
        .then((datas) => {
          commit("SET_DATAS", datas.data);
        })
        .catch((res) =>
          ApiErrorHandler.handle(res, dispatch, rootState.users.credentials)
        );

      commit("LOADING", false);
    },
  },

  mutations: {
    LOADING(state, status) {
      state.status.loading = status;
    },

    SET_DATAS(state, datas) {
      state.datas = datas;
    },
  },
};
